import React from "react";
// import phoneIcon from "../images/phone-icon.svg";
// import emailIcon from "../images/email-icon.svg";
import instagramLogo from "../images/instagram-icon.svg";
import emailLogo from "../images/email-icon.svg";
import twitterLogo from "../images/twitter.svg";

const styles = {
  main: {
    backgroundColor: "black",
    color: "#fff",
    marginTop: 50
  },
  icon: {
    height: 35,
    width: 35,
    marginBottom: 30
  },
  noOutline: {
    outline: "none"
  }
};

function Logo(props) {
  return (
    <>
      <img style={styles.icon} src={props.logo} alt="" />
    </>
  );
}

export default function ContactUs() {
  return (
    <div style={styles.main} id="contact-us">
      <h3 className="text-center pt-3">Contact us</h3>
      <br />
      <br />
      <div className="row m-0 text-center">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <button
            style={{
              backgroundColor: "black",
              border: "none",
              outline: "none"
            }}
            type="button"
            onClick={() => alert("Email at : girlscriptmumbai@gmail.com")}
          >
            <img
              style={{ height: 35, width: 35, marginBottom: 30 }}
              src={emailLogo}
              alt=""
            />
          </button>
        </div>
        <a
          style={styles.noOutline}
          href="https://www.instagram.com/girlscriptmumbai/"
          className="col-sm-4 col-md-4 col-lg-4"
        >
          <Logo logo={instagramLogo} />
        </a>
        <a
          style={styles.noOutline}
          href="https://twitter.com/GSFMumbai"
          className="col-sm-4 col-md-4 col-lg-4"
        >
          <Logo logo={twitterLogo} />
        </a>
        <br />
        <br />
      </div>
      <br />
      <div className="text-center">
        <span
          className="text-muted text-center"
          style={{ textAlign: "center !important" }}
        >
          &copy; All rights reserved by GirlScript Mumbai 2019. | Developed by{" "}
          <a href="https://ehtesham.dev/">
            Ehtesham Siddiqui.
          </a>
        </span>
      </div>
      <br />
    </div>
  );
}
